var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "courseL",
      },
      [
        _vm.CoordinatorList.length > 0
          ? _c(
              "div",
              { staticClass: "list" },
              _vm._l(_vm.CoordinatorList, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "listItem" },
                  [_c("winCourseDeYu", { attrs: { item: item } })],
                  1
                )
              }),
              0
            )
          : _c(
              "div",
              { staticStyle: { "margin-top": "50px", "text-align": "center" } },
              [_c("img", { attrs: { src: _vm.$store.getters.noData } })]
            ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "paginationX" },
      [
        _vm.totalNumber > 0
          ? _c("el-pagination", {
              attrs: {
                background: "",
                "current-page": _vm.page.pageNumber,
                "page-size": _vm.page.pageSize,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.totalNumber,
              },
              on: {
                "current-change": _vm.handleCurrentChange,
                "size-change": _vm.handleSizeChange,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }